export const ENDING_RARITY_VALUES = ["common", "uncommon", "rare", "legendary"];
export const EndingRarity = {
    COMMON: "common",
    UNCOMMON: "uncommon",
    RARE: "rare",
    LEGENDARY: "legendary",
};
export const PARTICLE_INTENSITY_VALUES = ["none", "low", "high", "max"];
export const ParticleIntensity = {
    NONE: "none",
    LOW: "low",
    HIGH: "high",
    MAX: "max",
};
export const ENDING_RARITY_META = {
    [EndingRarity.COMMON]: { label: "Common ending", maxUnlockedPercent: 100, particles: ParticleIntensity.NONE },
    [EndingRarity.UNCOMMON]: { label: "Uncommon ending", maxUnlockedPercent: 25, particles: ParticleIntensity.LOW },
    [EndingRarity.RARE]: { label: "Rare ending", maxUnlockedPercent: 5, particles: ParticleIntensity.HIGH },
    [EndingRarity.LEGENDARY]: { label: "Legendary ending", maxUnlockedPercent: 1, particles: ParticleIntensity.MAX },
};
